import { PageLoad } from '../elasticApmOptions';

// The Transaction type from apm-rum is incorrect. Transaction object has properties like id, traceId, _end, _start.. etc
export const getPageLoad = (transaction: any): PageLoad | null => {
  if (transaction) {
    return {
      pageLoadTraceId: transaction.traceId,
      pageLoadSampled: false,
    };
  }
  return null;
};
